import axios from "axios";
import { useEffect, useState } from "react";
import authServices from "../../../../services/authServices";
import dataProvider from "../../../../services/dataProvider";
import DataTable from "../../common/data-table/data-table";

const ActivityLog = () => {
    const [tableHeader, setTableHeader] = useState([
        { name: "Log Id", key: "logID" },
        { name: "Activity By", key: "fullName" },
        { name: "Log Message", key: "message" },
        { name: "Date/Time", key: "timestamp" },
    ]);
    const [tableData, setTableData] = useState([]);
    const [fetchComplete, setFetchComplete] = useState(false);
    const [taskLoading, setTaskLoading] = useState(false);
    const [searchText, setSearchText] = useState("");

    function parseData(data) {
        let allFormData = [];
        //console.log(data);
        
        data.forEach((formState) => {

            let dateString = new Date(formState.data.timestamp._seconds * 1000).toDateString() ;
            let timeString = new Date(formState.data.timestamp._seconds * 1000).toISOString().substr(11, 8) ;

            allFormData.push({
                logID : formState.data.timecreated,
                fullName: formState.data.fullName,
                message: formState.data.message ,
                timestamp  : dateString + " " + timeString,
                timestampInSeconds : `${formState.data.timestamp._seconds}`
            });
        });

        return allFormData;
    }

    useEffect(()=>{
        var config = {
            method: "post",
            url: dataProvider.baseUrl + "getActivityLog",
            headers: {
                token: authServices.getToken(),
                orgid: authServices.getOrgId(),
            },
        };

        //console.log("CONFIG",config)

        axios(config)
            .then(function (response) {
                // console.log("Logs", response.data);
                setFetchComplete(true);
                if(response.data.status === "success") {
                    let data = parseData(response.data.message);
                    setTableData(data);
                } 
            })
            .catch((error) => {
                setFetchComplete(true);
                console.error(error);
            });
    },[])

    return (
        <div id="tasks">
            <div className="container-fluid p-0">
                <div className="d-flex align-items-center flex-row card p-4 no-radius border-0 border-bottom">
                    <div className="m-0 h5">Activity Logs</div>
                </div>
            </div>

            <div className="container-fluid p-3 pb-0">
                <div className="card p-4 border-0">
                    <div className="d-flex align-items-center">
                        <label htmlFor="search">Search for Member Log : </label>
                        <div className="ms-3">
                            <input
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                type="text"
                                placeholder="Type Name or Registration"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid p-3">
                <div className="card p-3 border-0">
                    {fetchComplete ? (
                        <div className="position-relative">

                            <DataTable 
                                sortBy="timestampInSeconds" 
                                reverseSort={true} 
                                search={searchText}
                                header={tableHeader} 
                                rawData={tableData} 
                                paginate
                            />

                            {taskLoading && (
                                <div
                                    className="position-absolute top-0 left-0 w-100 h-100 bg-dark"
                                    style={{ zIndex: "99", opacity: "0.1", cursor: "wait" }}
                                ></div>
                            )}
                        </div>
                    ) : (
                        <div className="">
                            <div className="d-flex align-items-center justify-content-center">
                                <div className="me-3">Fetching Data</div>
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ActivityLog;
